import hunt from 'huntjs';

function lazyLoadImage() {
    const $oldImage = this;
    const $newImage = new Image();

    $newImage.src = $oldImage.dataset.src;
    $newImage.onload = () => {
        $newImage.classList = $oldImage.classList;
        $oldImage.classList.add('is-hidden');
        $newImage.classList.add('is-loaded');
    };

    $oldImage.parentNode.insertBefore($newImage, $oldImage.parentNode.childNodes[0]);
}

function lazyLoadBackgroundImage() {
    const background = this.dataset.src;

    this.style.backgroundImage = `url('${background}')`;
    this.classList.add('is-loaded');
}

document.addEventListener('DOMContentLoaded', () => {
    hunt(document.getElementsByClassName('js-image'), {
        enter: lazyLoadImage,
        offset: 300,
    });

    hunt(document.getElementsByClassName('js-bg-image'), {
        enter: lazyLoadBackgroundImage,
        offset: 300,
    });
});
